import { render, staticRenderFns } from "./MenuInsightsQuestionOffline.vue?vue&type=template&id=86c54214&"
import script from "./MenuInsightsQuestionOffline.vue?vue&type=script&lang=js&"
export * from "./MenuInsightsQuestionOffline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerGears});
